import { Component, Input, OnInit } from '@angular/core';
import { FunctionalCapabilitiesDetailXMLSection } from 'src/app/model/shared/functional-capabilities-details-xml-section';
import { Section } from 'src/app/model/shared/section';

@Component({
  selector: 'app-functional-capabilities-details-xml-section',
  templateUrl: './functional-capabilities-details-xml-section.component.html',
  styleUrls: ['./functional-capabilities-details-xml-section.component.scss']
})
export class FunctionalCapabilitiesDetailsXmlSectionComponent implements OnInit {
  @Input() sections: FunctionalCapabilitiesDetailXMLSection[] = [];
  constructor() {}

  ngOnInit(): void {}
}
